import React from 'react';
import { useSelector } from 'react-redux';
import {ToastProvider} from './Toast'
import { hobOrgSelector } from '../redux/selector';
import HouseOfBrandsMmt from './mmt-components/HouseOfBrandsMmt/HouseOfBrandsMmt';
import HouseOfBrands from './gi-components/HouseOfBrands/HouseOfBrands';

const HobLandingPage = (props) => {
  const orgId = useSelector(hobOrgSelector)
  return (
    <ToastProvider>
      {orgId === "MMT" ? <HouseOfBrandsMmt {...props} /> : <HouseOfBrands {...props} /> }
    </ToastProvider>
  )
}

export default HobLandingPage;